import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  getSKUWithoutPrefix,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

import { nose, bottom } from './vulcans.mjs'

const frameType = 'TF'

export const ghost = {
  id: 'ghost',
  name: 'Ghost Frame',
  hasOptions: false,
  imgproxySettings,
  mobileImgproxySettings,
  opacity: 0.5,
  pathTemplate: `gs://sg360/220520/Ghost Frames/Vulcans/${frameType}/Vulcans ${frameType} Ghost_{nnn}.png`,
}

function resolveOptions(customisedProduct) {
  const options = {
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
  }

  if (customisedProduct.frameType === 'ff') delete options.nose
  if (customisedProduct.frameType === 'tf') delete options.bottom

  return options
}

export default {
  layers: [background, ghost, nose, bottom],
  resolveOptions,
  resolveOptionsFromSKU,
}
